<template>
  <b-container>
    <div class="pb-lg-5 pt-lg-5">
      <b-row>
        <div class="col-lg-3 col-md-3 col-sm-2"></div>
        <div class="col-lg-6 col-md-6 col-sm-8 col-xs-12">
          <h2 class="text-center mb-3">Create a new account</h2>

          <b-form @submit.prevent="SignupUser">
            <b-form-group id="input-group-1" label="First Name" label-for="id_name" class="text-left">
              <b-form-input
                id="id_name"
                v-model="form.name"
                type="text"
                class="form-control form-control-sm validate"
                required
                placeholder="Enter your first name">
              </b-form-input>
            </b-form-group>

            <b-form-group id="input-group-6" label="Surname" label-for="id_surname" class="text-left">
              <b-form-input
                id="id_surname"
                v-model="form.surname"
                type="text"
                class="form-control form-control-sm validate"
                placeholder="Enter your surname">
              </b-form-input>
            </b-form-group>

            <b-form-group id="input-group-2" label="Username" label-for="id_username" class="text-left">
              <b-form-input
                id="id_username"
                v-model="form.username"
                type="text"
                class="form-control form-control-sm validate"
                required
                placeholder="Enter your username">
              </b-form-input>
            </b-form-group>

            <b-form-group id="input-group-3" label="Email" label-for="id_email" class="text-left">
              <b-form-input
                id="id_email"
                v-model="form.email"
                type="text"
                required
                class="form-control form-control-sm validate"
                placeholder="Enter your email">
              </b-form-input>
            </b-form-group>

            <b-form-group v-show="checkMatch" label="Password" class="text-left">
              <b-form-input
                id="id_password"
                v-model="form.password"
                type="password"
                class="form-control form-control-sm validate"
                required
                autocomplete="new-password"
                placeholder="Enter your password">
              </b-form-input>
            </b-form-group>

            <b-form-group v-show="checkMatch" label="Repeat password" class="text-left">
              <b-form-input
                id="id_repeat_password"
                v-model="form.repeatPassword"
                type="password"
                class="form-control form-control-sm validate"
                required
                autocomplete="new-password"
                placeholder="Repeat your password">
              </b-form-input>
            </b-form-group>

            <b-form-group v-show="!checkMatch" label="Password" class="text-left">
              <b-form-input
                style="border: solid red"
                id="id_password"
                v-model="form.password"
                type="password"
                class="form-control form-control-sm validate"
                required
                autocomplete="new-password"
                placeholder="Enter your password">
              </b-form-input>
            </b-form-group>

            <b-form-group v-show="!checkMatch" label="Password" class="text-left">
              <b-form-input
                style="border: solid red"
                id="id_repeat_password"
                v-model="form.repeatPassword"
                type="password"
                class="form-control form-control-sm validate"
                required
                autocomplete="new-password"
                placeholder="Repeat your password">
              </b-form-input>
            </b-form-group>

            <b-button type="submit" class="btn btn-block" variant="info">Signup</b-button>

          </b-form>
          <div class="mt-lg-5 text-center">
            <router-link :to="{name: 'home'}" class="text-info">Home page</router-link>
            &bullet;
            Already have an account?
            <router-link :to="{name: 'login'}" class="text-info">Login</router-link>
          </div>
        </div>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import {mapGetters} from 'vuex'


export default {
  name: 'signup',
  components: {
    Navbar,
    Footer
  },
  created() {
    if(this.userFromComputed())
     this.showMsgLoggedIn();
  },
  computed: {
    ...mapGetters([
      'authenticatedUser'
    ])
  },
  data () {
    return {
      checkMatch: true,
      email: '',
      form: {
        name: '',
        surname: '',
        username: '',
        email: '',
        password: '',
        repeatPassword: ''
      }
    }
  },
  methods: {
    userFromComputed() {
          return this.authenticatedUser;
      },
    showMsgLoggedIn (){
        this.$bvModal.msgBoxOk('You are already logged in', {
          okVariant: 'btn clbutton btn-secondary btn-sm'
        }) .then(value => {
          this.$router.push('/');
        })
        .catch(error => {
          
        })   
    },
    showMsgSuccess () {
      // this.boxOne = ''
      // Login the user with the given credentials
      // let credentials = {
      //   login: this.form.username,
      //   password: this.form.password,
      //   email: this.form.email
      // }
      // this.$store.dispatch('login', credentials)
      //   .then(response => {})

      this.$bvModal.msgBoxOk('User successfully registered. An email has been sent to the provided email address with instructions for the account confirmation.', {
        okVariant: 'success'
      })
        .then(value => {
          this.boxOne = value
          if (this.boxOne) {
            this.$router.push({name: 'home'})
          } else {
          }
        })
        .catch(error => {
          alert('An error occurred! Please refresh the page.' + error)
        })
    },
    showMsgFail (errorMessage) {
      this.boxOne = ''
      this.$bvModal.msgBoxOk(errorMessage, {
        okVariant: 'danger'
      })
        .then(value => {
          this.boxOne = value
          if (this.boxOne) {
            window.location.reload()
          } else {
          }
        })
        .catch(error => {
          alert('An error occurred! Please refresh the page.' + error)
        })
    },
    showMsgNoMatch () {
      this.boxOne = ''
      this.$bvModal.msgBoxOk('The passwords do not match. Please try again.', {
        okVariant: 'danger'
      })
        .then(value => {
          this.boxOne = value
          if (this.boxOne) {
            this.form.password = ''
            this.form.repeatPassword = ''
          } else {
          }
        })
        .catch(error => {
          alert('An error occurred! Please refresh the page.' + error)
        })
    },
    SignupUser (event) {
      let profile = {
        login: this.form.username,
        name: this.form.name,
        surname: this.form.surname,
        email: this.form.email,
        password: this.form.password
      }

      if (this.form.password === this.form.repeatPassword) {
        this.$store.dispatch('signup', profile).then(response => {
          if (response.status === 200) {
            this.showMsgSuccess()
          }
          //  else if (response.status === 400)
          // {
          //   console.log(33)
          //   this.showMsgFail(error.response.data)
          // }
          else {
          console.log(response)
          if (response) { this.showMsgFail(response)}
          else{}
            
}
        })
           .catch((data) => {
              console.log("data")
              console.log(data)
            this.showMsgFail()
           })
      } else {
        this.showMsgNoMatch()
        this.checkMatch = false
      }
    }
  }
}
</script>

<style scoped>
  .b-form-input.invalid input {
    border: 1px solid red;
  }
</style>



// WEBPACK FOOTER //
// src/views/Signup.vue